/**
 * "Chrome · Windows" a partir do User-Agent. Não precisa ser perfeito: serve para o
 * admin ver que a mesma conta apareceu num aparelho diferente do de sempre.
 */
export const descreverAparelho = (ua?: string | null): string => {
  if (!ua) return "Aparelho desconhecido";

  const navegador =
    /Edg\//.test(ua) ? "Edge"
    : /OPR\/|Opera/.test(ua) ? "Opera"
    : /SamsungBrowser/.test(ua) ? "Samsung Internet"
    : /Firefox\//.test(ua) ? "Firefox"
    : /Chrome\/|CriOS\//.test(ua) ? "Chrome"
    : /Safari\//.test(ua) ? "Safari"
    : /okhttp|curl|python|java/i.test(ua) ? "Script"
    : "Navegador";

  const sistema =
    /iPhone/.test(ua) ? "iPhone"
    : /iPad/.test(ua) ? "iPad"
    : /Android/.test(ua) ? "Android"
    : /Windows/.test(ua) ? "Windows"
    : /Mac OS X|Macintosh/.test(ua) ? "Mac"
    : /Linux/.test(ua) ? "Linux"
    : "";

  return sistema ? `${navegador} · ${sistema}` : navegador;
};

/** "Goiânia · Goiás", com o país só quando não é o Brasil. */
export const cidadeDoLog = (l: { geoCity?: string | null; geoRegion?: string | null; geoCountry?: string | null }) => {
  const pais = l.geoCountry && l.geoCountry !== "BR" ? ` (${l.geoCountry})` : "";
  if (l.geoCity) return [l.geoCity, l.geoRegion].filter(Boolean).join(" · ") + pais;
  if (l.geoRegion) return l.geoRegion + pais;
  return l.geoCountry ?? null;
};
